import { STATUSES } from '@/constants/statuses'
import { ROUTE_STATUSES } from '@/modules/dispatcher/constants/routes'

export const ALLOWED_TOP_STATUSES = [
    {
        id: 'all',
        name: 'Все',
        color: 'purple',
    },
    {
        id: STATUSES.WAITING_START_COOKING,
        name: 'Ждет начала приготовления',
        color: 'orange',
    },
    {
        id: STATUSES.COOKING,
        name: 'Начали готовить',
        color: 'green',
    },
    {
        id: STATUSES.COLLECTED,
        name: 'Собран',
        color: 'gray',
    },
    {
        id: STATUSES.ON_THE_WAY,
        name: 'В пути',
        color: 'blue',
    },
]

export const STAFF_ALLOWED_TOP_STATUSES = [
    {
        id: 'all',
        name: 'Все',
        color: 'purple',
    },
    {
        id: STATUSES.EDITING,
        name: 'Редактируется',
        color: 'orange',
    },
    {
        id: STATUSES.COOKING,
        name: 'Начали готовить',
        color: 'green',
    },
    {
        id: STATUSES.COMPLETED,
        name: 'Исполнен',
        color: 'gray',
    },
    {
        id: STATUSES.SEND_ERROR,
        name: 'Ошибка отправки',
        color: 'red',
    },
    {
        id: STATUSES.CANCELED,
        name: 'Отменен',
        color: 'red',
    },
]

export const colorMap = {
    purple: { base: '#6f42c1', light: '#e2d9f3', active: '#8C68CD' },
    orange: { base: '#CA6510', light: '#FFE5D0', active: '#FD9843' },
    green: { base: '#146C43', light: '#D2F4EA', active: '#479F76' },
    gray: {
        base: '#6C757D',
        light: '#E9ECEF',
        active: '#ced4da',
        dark: '#9ca3ab',
    },
    blue: { base: '#087990', light: '#CFF4FC', active: '#0dcaf0' },
    red: { base: '#B02A37', light: '#F8D7DA', active: '#E35D6A' },
}

export const DEFAULT_COLORS = {
    base: '#6c757d',
    light: '#e9ecef',
    active: '#adb5bd',
}

export const ALL_COURIERS_OPTION = { id: '', label: 'Все курьеры' }
export const ALL_STATUSES_OPTION = { id: 'all', label: 'Все статусы' }

export const TEXT_FILTER_FIELD_MAP = {
    orderNumber: 'num',
    address: 'address',
}

export const DEFAULT_FILTER_VALUES = {
    status: 'all',
    courier: '',
}

export const TABLE_STATUSES = [
    {
        id: STATUSES.WAITING_START_COOKING,
        name: 'Ждет начала приготовления',
        badgeColor: 'orange',
        tableColor: '#FD7E14',
    },
    {
        id: STATUSES.SENT_TO_DIVISION,
        name: 'Отправлен в подразделение',
        badgeColor: 'blue',
        tableColor: '#17A2B8',
    },
    {
        id: STATUSES.COOKING,
        name: 'Начали готовить',
        badgeColor: 'green',
        tableColor: '#28A745',
    },
    {
        id: STATUSES.COLLECTED,
        name: 'Собран',
        badgeColor: 'gray',
        tableColor: '#6C757D',
    },
    {
        id: STATUSES.ON_THE_WAY,
        name: 'В пути',
        badgeColor: 'blue',
        tableColor: '#17A2B8',
    },
    {
        id: STATUSES.DELIVERED,
        name: 'Доставлен',
        badgeColor: 'green',
        tableColor: '#343A40',
    },
    {
        id: STATUSES.COMPLETED,
        name: 'Исполнен',
        badgeColor: 'gray',
        tableColor: '#343A40',
    },
    {
        id: STATUSES.SEND_ERROR,
        name: 'Ошибка отправки',
        badgeColor: 'red',
        tableColor: '#DC3545',
    },
    {
        id: STATUSES.CANCELED,
        name: 'Отменен',
        badgeColor: 'red',
        tableColor: '#DC3545',
    },
    {
        id: STATUSES.CANCELED_BY_MANAGER,
        name: 'Отменен менеджером',
        badgeColor: 'red',
        tableColor: '#DC3545',
    },
]

export const STAFF_TABLE_STATUSES = [
    {
        id: STATUSES.EDITING,
        name: 'Редактируется',
        badgeColor: 'orange',
        tableColor: '#FD7E14',
    },
    {
        id: STATUSES.WAITING_START_COOKING,
        name: 'Ждет начала приготовления',
        badgeColor: 'orange',
        tableColor: '#FD7E14',
    },
    {
        id: STATUSES.SENT_TO_DIVISION,
        name: 'Отправлен в подразделение',
        badgeColor: 'blue',
        tableColor: '#17A2B8',
    },
    {
        id: STATUSES.COOKING,
        name: 'Начали готовить',
        badgeColor: 'green',
        tableColor: '#28A745',
    },
    {
        id: STATUSES.COMPLETED,
        name: 'Исполнен',
        badgeColor: 'gray',
        tableColor: '#343A40',
    },
    {
        id: STATUSES.SEND_ERROR,
        name: 'Ошибка отправки',
        badgeColor: 'red',
        tableColor: '#DC3545',
    },
    {
        id: STATUSES.CANCELED,
        name: 'Отменен',
        badgeColor: 'red',
        tableColor: '#DC3545',
    },
]

export const ROUTE_ORDER_BADGE_STATUSES_MAP = [...TABLE_STATUSES].reduce(
    (acc, item) => {
        acc[item.id] = {
            color: item.badgeColor || 'gray',
            name: item.name || 'Неизвестно',
        }
        return acc
    },
    {}
)

export const TABLE_STATUS_STYLES_MAP = [
    ...TABLE_STATUSES,
    ...STAFF_TABLE_STATUSES,
].reduce((acc, item) => {
    acc[item.name] = {
        backgroundColor: item.tableColor || '#6c757d',
        color: 'white',
    }
    return acc
}, {})

export const ROUTE_STATUSES_FILTER = [
    {
        id: 'all',
        name: 'Все',
        color: 'purple',
    },
    {
        id: ROUTE_STATUSES.NEW,
        name: 'Новый',
        color: 'blue',
    },
    {
        id: ROUTE_STATUSES.FORMING,
        name: 'Формируется',
        color: 'orange',
    },
    {
        id: ROUTE_STATUSES.ASSIGNED,
        name: 'Назначен',
        color: 'green',
    },
    {
        id: ROUTE_STATUSES.IN_PROGRESS,
        name: 'В работе',
        color: 'blue',
    },
    {
        id: ROUTE_STATUSES.COMPLETED,
        name: 'Исполнен',
        color: 'gray',
    },
    {
        id: ROUTE_STATUSES.CANCELED,
        name: 'Отменён',
        color: 'red',
    },
]

export const ROUTE_STATUSES_MAP = ROUTE_STATUSES_FILTER.reduce((acc, item) => {
    acc[item.id] = item
    return acc
}, {})

export const ROUTE_FILTER_ALL = 'all'

// Дефолтные значения для API-фильтров
export const DEFAULT_API_FILTERS = {
    num: '',
    address: '',
    price_min: null,
    price_max: null,
    courier_id: '',
    statuses: TABLE_STATUSES.map(s => s.id),
}

export const STAFF_DEFAULT_API_FILTERS = {
    ...DEFAULT_API_FILTERS,
    statuses: STAFF_TABLE_STATUSES.map(s => s.id),
}

export const ORDER_NUMBER_MAX_LENGTH = 9
export const ORDER_ADDRESS_MAX_LENGTH = 100
export const ORDER_AMOUNT_MAX_LENGTH = 10
